import React from 'react';
import { QueueKey } from 'flow/types/EntityKeys';
import { selectQueueActiveProfileAvailable } from 'flow/selectors/queue-selectors';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import BarItemsInfo from 'flow/components/pbx/supervisor/QueueRow/BarItemsInfo';

interface Props {
    queueKey: QueueKey;
    number?: number;
}

const AgentsLoggedInInfo = ({ queueKey, number }: Props) => {
    const { i18next } = useAppContext();
    const queueIsOpen = useAppSelector((state) =>
        selectQueueActiveProfileAvailable(state, queueKey),
    );

    const shouldHighlightItem = queueIsOpen && !number;

    return (
        <BarItemsInfo
            tooltipLabel={i18next.t('Queue.HandleMembers.Title')}
            icon={'headset'}
            number={number}
            className={shouldHighlightItem ? 'bg-red' : ''}
            iconClassName={shouldHighlightItem ? 'text-white' : 'text-black'}
        />
    );
};

export default AgentsLoggedInInfo;
